<template>
  <transition name="fade">
    <v-layout v-if="isFailed" align-center justify-center column fill-height class="mt-5">
      {{ $t('Common.genericErrorMsg') }}
      <br />
      <a
        :title="$t('Common.tryAgain')"
        class="accent--text"
        @click.prevent="tryAgain"
      >{{ $t('Common.tryAgain') }}.</a>
    </v-layout>
  </transition>
</template>

<script>
export default {
  name: 'TryAgain',
  props: {
    isFailed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    tryAgain () {
      this.$emit('tryAgain')
    }
  }
}
</script>
